import { FormField } from 'components/form/customFormField'
import { Control, FieldErrors } from 'react-hook-form'

interface EventDataFieldsProps {
    control: Control<any, any>
    errors: FieldErrors<any>
}

export const EventDataFields: React.FC<EventDataFieldsProps> = ({ control, errors }: EventDataFieldsProps) => (
    <>
        <FormField
            name="selling_start_date"
            control={control}
            errors={errors}
            label="Értékesítés kezdete"
            type="datetime-local"
            rules={{ required: 'Az időpont megadása kötelező.' }}
        />

        <FormField
            name="selling_end_date"
            control={control}
            errors={errors}
            label="Értékesítés vége"
            type="datetime-local"
            rules={{
                required: 'Az időpont megadása kötelező.',
                validate: {
                    afterSellingStart: (value: string | number | Date) =>
                        new Date(value) > new Date((document.getElementsByName('selling_start_date')[0] as HTMLInputElement).value) ||
                        'Az értékesítés vége nem lehet korábban, mint az értékesítés kezdete!',
                },
            }}
        />

        <FormField
            name="event_date"
            control={control}
            errors={errors}
            label="Esemény időpontja"
            type="datetime-local"
            rules={{
                required: 'Az időpont megadása kötelező.',
                validate: {
                    afterSellingEnd: (value: string | number | Date) =>
                        new Date(value) >= new Date((document.getElementsByName('selling_end_date')[0] as HTMLInputElement).value) ||
                        'Az esemény időpontja nem lehet korábban, mint a jegyértékesítés vége!',
                    afterSellingStart: (value: string | number | Date) =>
                        new Date(value) > new Date((document.getElementsByName('selling_start_date')[0] as HTMLInputElement).value) ||
                        'Az esemény időpontjának meg kell haladnia az értékesítés kezdetének dátumát!',
                },
            }}
        />

        <FormField name="description" control={control} errors={errors} label="Esemény leírása" placeholder="Leírás..." textarea />
        <FormField
            name="social_media_link"
            control={control}
            errors={errors}
            label="Esemény közösségi média linkje"
            placeholder="Link"
            rules={{
                pattern: {
                    value: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,6}(\S*)?$/,
                    message: 'Érvényes URL-t kell megadni!',
                },
            }}
        />
    </>
)
